export default __webpack_public_path__ + "static/media/close.489e5ac1.svg";